import { FieldWrapper } from '../FieldWrapper';
import { TextInput } from '../FormItems';

type FieldWrapperProps = React.ComponentProps<typeof FieldWrapper>;

type PasswordTextFieldProps = {
  passwordInput?: React.ComponentProps<typeof TextInput>;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

export const PasswordTextField = ({
  fieldWrapperProps,
  passwordInput,
  ...rest
}: PasswordTextFieldProps): JSX.Element => (
  <FieldWrapper {...fieldWrapperProps}>
    <TextInput id={fieldWrapperProps.htmlFor} type='password' {...rest} {...passwordInput} />
  </FieldWrapper>
);
